import { getSelf } from '@modules/auth/auth.Dux'
import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import AccessDenied from '../admin/screens/AccessDenied'

const PrivateRoute = ({ component: Component, adminType, adminTypes, permission, user, ...params }) => (
  <Route
    {...params}
    render={(props) => {
      if (user.isSuperAdmin) {
        return <Component {...props} />
      }

      if (adminType && user.profile.type === adminType) {
        return <Component {...props} />
      }

      if (adminType === 'company' && user.isCompanyAdmin) {
        return <Component {...props} />
      }

      if (adminType === 'provider' && user.isProviderAdmin) {
        return <Component {...props} />
      }

      if (adminTypes && adminTypes.includes(user.profile.type)) {
        return <Component {...props} />
      }

      // if (permission && user.hasPermission(permission)) {
      //   return <Component { ...props } />
      // }

      return <AccessDenied />
    }}
  />
)

const mapStateToProps = (state) => ({
  user: getSelf(state),
})

export default connect(mapStateToProps)(PrivateRoute)
